var Model = require("../types/Model.js");

module.exports = new Model({
	name: "callgroupscalling",
	init: init,
	listeners: listeners,
	triggers: triggers,

	call: call,
	clear: clear,
	recalculate: recalculate,
	getNextMember: getNextMember
});

var BUSY_TIME = 4 * 1000;

function init(){
	this.extend({
		group: null,
		busy: false
	});

	this._stats = {};
	this._callgroups = [];
	this._currentMembers = [];
	this._availableMembers = [];

	this._currentIndex = 0;

	this._started = false;
	this._voiceOnly = false;
	this._shouldClear = false;

	this._stats = null;
	this._rawCurrent = null;
	this._busyTimeout = null;
}

function triggers(){
	return {
		"call": handle_call,
		"cancel": handle_cancel
	};
}

function listeners(){
	return {
		"callgroups:updated": Model.makeRecalculator("callgroups"),
		"callgroupsmembers:updated": Model.makeRecalculator("members"),
		"buzz:state:idle": handle_idle,
		"buzz:state:connected": handle_connected
	};
}

function recalculate(){
	var started = this._started;
	var groupId = this._rawCurrent;
	var callgroups = makeMap(this._callgroups);
	var members = this._members;

	if(!started) return;

	var currentGroup = callgroups[groupId];
	var currentMembers = members[groupId].slice();

	this._currentGroup = currentGroup;
	this._currentMembers = currentMembers;

	this.extend({
		group: currentGroup,
	});
}

function handle_call(data){
	var group = data.group;
	var voiceOnly = data.voiceOnly;

	this._started = true;
	this._rawCurrent = group;
	this._voiceOnly = voiceOnly;
	this.recalculate();

	this._stats = this._currentMembers.shift();
	this._availableMembers = shuffle(this._currentMembers);
	this.call();
}

function call(){
	var group = this._currentGroup;
	var voiceOnly = this._voiceOnly;
	var started = this._started;
	var stats = this._stats;

	if(!started || !group || !stats.available) {
		let reasonCallFailed;
		if (!started) reasonCallFailed = "not started";
		if (!group) reasonCallFailed = "no group";
		if (!stats.available) reasonCallFailed = "no available members";
		this.emit("usermetrics:trigger:track", `fail to start ${group ? "group" : ""} ${voiceOnly ? "audio" : "video"} call in old calling`, {
			reason: reasonCallFailed,
			who: stats._id,
			group: group._id,
		});
		return;
	}

	if(!stats.nonBusy){
		this.extend({
			busy: true
		});
		this._busyTimeout = setTimeout(clear_busy.bind(this), BUSY_TIME);
		this.emit("usermetrics:trigger:track", `fail to start ${group ? "group" : ""} ${voiceOnly ? "audio" : "video"} call in old calling`, {
			reason: "all members are busy",
			who: stats._id,
			group: group._id,
		});
		return;
	}

	this.emit("calling:trigger:call", {
		who: this.getNextMember(),
		voiceOnly: voiceOnly,
		ignoreBusy: true,
		metadata: {
			callgroup: group._id
		}
	});
	this.emit("usermetrics:trigger:track", `start ${group ? "group" : ""} ${voiceOnly ? "audio" : "video"} call in old calling`, {
		group: group._id,
		who: stats._id,
	});
}

function handle_idle(){
	if(!this._started) return;
	if(this._shouldClear){
		this.clear();
		return;
	}
	this.call();
}

function handle_connected(){
	if(!this._started) return;
	this._shouldClear = true;
}

function handle_cancel(){
	this.emit("calling:trigger:hangup", {
		reason: "hangup"
	});
	this._shouldClear = true;

	this.emit("usermetrics:trigger:track", `hangup ${this._currentGroup ? "group" : ""} ${this._voiceOnly ? "audio" : "video"} call in old calling`, {
		group: this._currentGroup ? this._currentGroup._id : null,
		who: this._stats._id,
	});
}

function clear(){
	this._currentGroup = null;
	this._voiceOnly = false;
	this._started = false;
	this._currentIndex = 0;
	this._shouldClear = false;
	this.extend({
		group: null
	});
}

function clear_busy(){
	clearTimeout(this._busyTimeout);
	this._busyTimeout = null;

	this.extend({
		busy: false
	});
	this.clear();
}

function shuffle(array){
	var currentIndex = array.length;
	var randomIndex;
	var temp;

	while(currentIndex){
		randomIndex = Math.floor(Math.random() * currentIndex--);
		temp = array[currentIndex];
		array[currentIndex] = array[randomIndex];
		array[randomIndex] = temp;
	}

	return [].concat(array);
}

function getNextMember(){
	var availableMembers = this._availableMembers;
	var index = this._currentIndex;

	if(index === availableMembers.length)
		index = 0;

	var currentMember = availableMembers[index];
	this._currentIndex = ++index;
	return currentMember;
}

function makeMap(array){
	return array.reduce(function(acc, e){
		acc[e._id] = e;
		return acc;
	}, {});
}